import { useEffect, useState } from "react";
import { trackEvent } from "../../lib/analytics";
import { AnalyticsSchemas } from "../../lib/analyticsEvents";

const SearchComponent = ({ searchUnitText, setSearchUnitText, search, setPageSize, trackingContext }) => {
  const [localInputText, setLocalInputText] = useState(searchUnitText || '');
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const isSearchActive = !!searchUnitText;

  useEffect(() => {
    setLocalInputText(searchUnitText || '');
  }, [searchUnitText]);

  const trackSearch = (text) => {
    if (!trackingContext || !text) return;
    trackEvent(AnalyticsSchemas.webSearch, {
      search_context: trackingContext,
      term_length: text.length,
    });
  };

  const handleSearchClick = () => {
    const trimmedText = localInputText.trim();
    if(trimmedText === "" || trimmedText === null || trimmedText === undefined){
      setSearchUnitText(null)
    } else {
      setSearchUnitText(trimmedText);
      trackSearch(trimmedText);
    }
    if (search) {
      search(trimmedText); // Call the search function passed as prop
    }
    setIsMobileSearchOpen(false)
  };

  const handleCloseClicked = () => {
    setLocalInputText('');
    setSearchUnitText('');
    setIsMobileSearchOpen(false)
  }

  return (
    <>
      <div className="MobileSearchHolder h-9 basis-auto sm:basis-auto md:basis-auto lg:basis-60 rounded-md bg-[#FFFFFFDE] dark:darkThemeGradiantBg justify-between shadow-appShadow bg-white flex shrink grow-0 relative group px-3 gap-2 md:hidden">
        <button
          className="flex items-center justify-center"
          data-testid="mobile-search-open-button"
          onClick={() => setIsMobileSearchOpen(true)}
        >
          {/* Close icon SVG */}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clipPath="url(#clip0_211_3623)">
              <circle cx="9.58342" cy="9.58366" r="7.91667" stroke="#1E2A2C" strokeWidth="1.5" className="dark:stroke-white"/>
              <path
                d="M15.4167 15.417L18.3334 18.3337"
                stroke="#1E2A2C"
                strokeWidth="1.5"
                strokeLinecap="round"
                className="dark:stroke-white "
              />
            </g>
            <defs>
              <clipPath id="clip0_211_3623">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
      <div className={`searchHolder h-9 basis-auto sm:basis-auto md:basis-auto lg:basis-60 rounded-md bg-[#FFFFFFDE] dark:darkThemeGradiantBg justify-between shadow-appShadow bg-white shrink grow-0 relative group px-3 gap-2 md:flex hidden`}>
        <input
          className="bg-white dark:bg-transparent rounded-tl-lg rounded-bl-lg grow leading-5 text-sm font-medium placeholder:text-dark-grey dark:placeholder:text-white outline-none shadow-none text-dark-grey  dark:text-white"
          type="text"
          name="search"
          autoComplete="off"
          placeholder="Search"
          data-testid="search-input"
          value={localInputText}
          onChange={(e) => setLocalInputText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();

              setSearchUnitText(localInputText);
              trackSearch(localInputText.trim());
              if (search) {
                search(localInputText); // Call the search function passed as prop
              }
            }
          }}
        />

        {isSearchActive ? (
          // Close icon
          <button
            className="flex items-center justify-center"
            data-testid="search-clear-button"
            onClick={() => {
              setLocalInputText('');
              setSearchUnitText('');
              if (search) {
                search(""); // Call the search function passed as prop
              }
              setIsMobileSearchOpen(false)
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M5.33325 4.6377C5.52494 4.6377 5.69055 4.70595 5.82544 4.84082L9.99927 9.01465L14.1741 4.84082L14.2786 4.75488C14.3886 4.68143 14.5171 4.64383 14.6614 4.6416L14.802 4.65234C14.9374 4.67611 15.0569 4.73931 15.1584 4.84082L15.2473 4.94824C15.3233 5.06061 15.3616 5.18935 15.3616 5.33301C15.3616 5.47694 15.3235 5.60623 15.2473 5.71875L15.1584 5.8252L10.9836 9.99902L15.1584 14.1738L15.2444 14.2783C15.3179 14.3884 15.3554 14.5167 15.3577 14.6611L15.3469 14.8018C15.3311 14.8921 15.2978 14.9752 15.2473 15.0508L15.1584 15.1582C15.0235 15.2931 14.858 15.3613 14.6663 15.3613C14.5226 15.3613 14.3938 15.3231 14.2815 15.2471L14.1741 15.1582L9.99927 10.9834L5.82544 15.1582C5.72784 15.2558 5.61124 15.3179 5.47778 15.3438L5.33813 15.3574C5.19236 15.3596 5.06178 15.3228 4.94849 15.2471L4.84106 15.1582C4.7063 15.0233 4.63794 14.8576 4.63794 14.666C4.63803 14.4745 4.70624 14.3086 4.84106 14.1738L9.01489 9.99902L4.84106 5.8252C4.74352 5.72764 4.6824 5.61092 4.65649 5.47754L4.64185 5.33789C4.63895 5.14361 4.70569 4.97618 4.84106 4.84082L4.94849 4.75195C5.0608 4.67609 5.18968 4.63771 5.33325 4.6377Z"
                fill="#1E2A2C"
                stroke="#1E2A2C"
                strokeWidth="0.15"
                className="dark:stroke-white dark:fill-white"
              />
            </svg>
          </button>
        ) : (
          // Search icon
          <button
            className="searchBtn rounded-tr-lg rounded-br-lg cursor-pointer"
            data-testid="search-button"
            onClick={handleSearchClick}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clipPath="url(#clip0_211_3623)" className="dark:stroke-white">
                <circle cx="9.58342" cy="9.58366" r="7.91667" stroke="#1E2A2C" strokeWidth="1.5" className="dark:stroke-white" />
                <path
                  d="M15.4167 15.417L18.3334 18.3337"
                  stroke="#1E2A2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  className="dark:stroke-white dark:fill-white"
                />
              </g>
              <defs>
                <clipPath id="clip0_211_3623">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        )}
      </div>

      {isMobileSearchOpen && (
        <div className="fixed inset-0 bg-white dark:bg-darkThemeBg flex justify-center items-start z-[999] w-full">
          <div className="bg-white dark:darkThemeGradiantbg dark:bg-transparent  p-4 rounded-md  w-full mt-8">
            <div className="flex items-center gap-2">
              <input
                className="bg-white dark:darkThemeGradiantBg grow leading-5 text-base lg:text-sm font-medium placeholder:text-dark-grey outline-none text-dark-grey border border-gray-300 rounded px-3 py-2 dark:bg-transparent dark:text-white dark:placeholder:text-white/40 focus:border-none"
                type="text"
                placeholder="Search"
                data-testid="mobile-search-input"
                value={localInputText}
                onChange={(e) => setLocalInputText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSearchClick();
                  }
                }}
              />
              <button onClick={handleSearchClick} data-testid="mobile-search-button">
                {/* Search icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clipPath="url(#clip0_211_3623)" className="*:dark:stroke-white">
                    <circle cx="9.58342" cy="9.58366" r="7.91667" stroke="#1E2A2C" strokeWidth="1.5" />
                    <path d="M15.4167 15.417L18.3334 18.3337" stroke="#1E2A2C" strokeWidth="1.5" strokeLinecap="round" />
                  </g>
                </svg>
              </button>
              <button onClick={handleCloseClicked} data-testid="mobile-search-close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" className="*:dark:stroke-white">
                  <path
                    d="M5.33325 4.6377L14.6663 15.3613M14.6663 4.6377L5.33325 15.3613"
                    stroke="#1E2A2C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SearchComponent;